import type { SVGProps } from "react";
const SenecPictogramContract = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M18.2071 12.7071L13.5 17.4142L10.2929 14.2071L11.7071 12.7929L13.5 14.5858L16.7929 11.2929L18.2071 12.7071Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 6C9.58172 6 6 9.58172 6 14C6 18.0796 9.05369 21.446 13 21.9381V32C13 32.5523 13.4477 33 14 33C14.5523 33 15 32.5523 15 32V21.9381C18.9463 21.446 22 18.0796 22 14C22 13.3094 21.9125 12.6392 21.748 12H30V18H36V23.9799L29.0747 32.5541L27.568 39.334L33.6415 36.2973L36 33.3772V39C36 39.5523 35.5523 40 35 40H16C15.4477 40 15 39.5523 15 39V37C15 36.4477 14.5523 36 14 36C13.4477 36 13 36.4477 13 37V39C13 40.6569 14.3431 42 16 42H35C36.6569 42 38 40.6569 38 39V30.901L44.8967 22.3622L40.3601 18.5817L38 21.5037V15.5858L32.4142 10H20.9297C19.5465 7.60879 16.9611 6 14 6ZM8 14C8 10.6863 10.6863 8 14 8C17.3137 8 20 10.6863 20 14C20 17.3137 17.3137 20 14 20C10.6863 20 8 17.3137 8 14ZM32 16V12.4142L35.5858 16H32ZM38.8967 23.5765L40.6399 21.4183L42.1033 22.6378L40.3601 24.796L38.8967 23.5765ZM37.6399 25.1326L39.1033 26.3521L32.3585 34.7027L30.432 35.666L30.9253 33.4459L37.6399 25.1326Z"
            fill="currentColor"
        />
        <path d="M24 24V26H17V24H24Z" fill="currentColor" />
        <path d="M27 28V30H17V28H27Z" fill="currentColor" />
        <path d="M17 34H25V32H17V34Z" fill="currentColor" />
        <path d="M24 38H17V36H24V38Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramContract;
